import { Navigate } from 'react-router-dom';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { AppRoutePath } from '@ocx-app/pages/AppRoutePath';
import { RedirectToRequestLink } from '@ocx-app/modules/auth/redirect-to-request-link.component';

import { RouteLoading } from '@ocx/ui';
import { RuntimeConfig, useConfiguration } from '@ocx/data-configuration';

import { useMembershipContext } from './membership.context';
import { Membership } from '../membership.types';

import type { ReactNode } from 'react';

export type MembershipGuardPros = {
  children: ReactNode;
  _isRedirectRequired?(membership: Membership, config: RuntimeConfig): boolean;
  redirectToPath?: string;
};

export const MembershipGuard = (props: MembershipGuardPros) => {
  const { children, _isRedirectRequired, redirectToPath = AppRoutePath.Home } = props;
  const { membership, loading } = useMembershipContext();
  const { config } = useConfiguration();

  if (loading && !membership) {
    return <RouteLoading />;
  }

  if (!membership) {
    return <RedirectToRequestLink />;
  }

  if (_isRedirectRequired?.(membership, config)) {
    return <Navigate to={redirectToPath} replace />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
